export default {
  amount: '預計存款金額',
  customer: '客戶姓名',
  number: '客戶賬號',
  children_account: '銀行子賬號', // 补充
  accountMaster: '艾德證券期貨有限公司',
  noSub: '無子賬戶申請記錄',
  success: '您的子賬戶申請已成功提交，如有問題請與我們聯繫',
  detailsTitle: '銀行子賬戶詳情',
  detailsBankName: '開戶銀行',
  detailsBankCardNumber: '銀行卡號',
  detailsPayeeName: '收款人姓名',
  detailsSwiftCode: 'SWIFT 代碼',
  detailsBankAddress: '銀行地址',
  detailsAliasAddress: '銀行英文地址',
  notCHN: '您好，該頁面無法查看！謝謝。 '
}
